import { TestDefinition, QuestionType } from '../../types';

// Helper scale 1-7 for PANSS and BPRS
const scale1to7 = [
  { label: '1 - Absent', value: 1 },
  { label: '2 - Minimal', value: 2 },
  { label: '3 - Mild', value: 3 },
  { label: '4 - Moderate', value: 4 },
  { label: '5 - Moderate-Severe', value: 5 },
  { label: '6 - Severe', value: 6 },
  { label: '7 - Extreme', value: 7 }
];

export const TESTS_PSICOSIS: TestDefinition[] = [
  {
    id: 'panss',
    code: 'PANSS',
    name: 'Positive and Negative Syndrome Scale',
    category: 'Psychosis',
    description: 'A 30-item scale to assess psychotic symptoms in schizophrenia. Developed by Kay et al. (1987). Includes positive symptoms (7), negative symptoms (7) and general psychopathology (16).',
    questions: [
      // POSITIVE SCALE (P1-P7)
      {
        id: 'p1',
        text: 'P1. Delusions',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Positive Symptoms'
      },
      {
        id: 'p2',
        text: 'P2. Conceptual disorganization',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Positive Symptoms'
      },
      {
        id: 'p3',
        text: 'P3. Hallucinatory behavior',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Positive Symptoms'
      },
      {
        id: 'p4',
        text: 'P4. Excitement',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Positive Symptoms'
      },
      {
        id: 'p5',
        text: 'P5. Grandiosity',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Positive Symptoms'
      },
      {
        id: 'p6',
        text: 'P6. Suspiciousness/Persecution',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Positive Symptoms'
      },
      {
        id: 'p7',
        text: 'P7. Hostility',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Positive Symptoms'
      },

      // NEGATIVE SCALE (N1-N7)
      {
        id: 'n1',
        text: 'N1. Blunted affect',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Negative Symptoms'
      },
      {
        id: 'n2',
        text: 'N2. Emotional withdrawal',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Negative Symptoms'
      },
      {
        id: 'n3',
        text: 'N3. Poor rapport',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Negative Symptoms'
      },
      {
        id: 'n4',
        text: 'N4. Passive/apathetic social withdrawal',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Negative Symptoms'
      },
      {
        id: 'n5',
        text: 'N5. Difficulty in abstract thinking',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Negative Symptoms'
      },
      {
        id: 'n6',
        text: 'N6. Lack of spontaneity and flow of conversation',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Negative Symptoms'
      },
      {
        id: 'n7',
        text: 'N7. Stereotyped thinking',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'Negative Symptoms'
      },

      // GENERAL PSYCHOPATHOLOGY (G1-G16)
      {
        id: 'g1',
        text: 'G1. Somatic concern',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'General Psychopathology'
      },
      {
        id: 'g2',
        text: 'G2. Anxiety',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'General Psychopathology'
      },
      {
        id: 'g3',
        text: 'G3. Guilt feelings',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'General Psychopathology'
      },
      {
        id: 'g4',
        text: 'G4. Tension',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'General Psychopathology'
      },
      {
        id: 'g5',
        text: 'G5. Mannerisms and posturing',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'General Psychopathology'
      },
      {
        id: 'g6',
        text: 'G6. Depression',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'General Psychopathology'
      },
      {
        id: 'g7',
        text: 'G7. Motor retardation',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'General Psychopathology'
      },
      {
        id: 'g8',
        text: 'G8. Uncooperativeness',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'General Psychopathology'
      },
      {
        id: 'g9',
        text: 'G9. Unusual thought content',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'General Psychopathology'
      },
      {
        id: 'g10',
        text: 'G10. Disorientation',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'General Psychopathology'
      },
      {
        id: 'g11',
        text: 'G11. Poor attention',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'General Psychopathology'
      },
      {
        id: 'g12',
        text: 'G12. Lack of judgment and insight',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'General Psychopathology'
      },
      {
        id: 'g13',
        text: 'G13. Disturbance of volition',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'General Psychopathology'
      },
      {
        id: 'g14',
        text: 'G14. Poor impulse control',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'General Psychopathology'
      },
      {
        id: 'g15',
        text: 'G15. Preoccupation',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'General Psychopathology'
      },
      {
        id: 'g16',
        text: 'G16. Active social avoidance',
        type: QuestionType.LIKERT,
        options: scale1to7,
        subscale: 'General Psychopathology'
      }
    ],
    subscales: [
      {
        name: 'Positive Symptoms',
        questionIds: ['p1', 'p2', 'p3', 'p4', 'p5', 'p6', 'p7'],
        description: 'Delusions, hallucinations, excitement, grandiosity, suspiciousness, hostility'
      },
      {
        name: 'Negative Symptoms',
        questionIds: ['n1', 'n2', 'n3', 'n4', 'n5', 'n6', 'n7'],
        description: 'Blunted affect, withdrawal, alogia, apathy, cognitive deficits'
      },
      {
        name: 'General Psychopathology',
        questionIds: ['g1', 'g2', 'g3', 'g4', 'g5', 'g6', 'g7', 'g8', 'g9', 'g10', 'g11', 'g12', 'g13', 'g14', 'g15', 'g16'],
        description: 'General symptoms: anxiety, depression, cognitive deficits, etc.'
      }
    ],
    interpretations: [
      { min: 30, max: 58, label: 'Remission / Minimal Symptoms', color: 'bg-green-100 text-green-800' },
      { min: 59, max: 75, label: 'Mild Symptoms', color: 'bg-yellow-100 text-yellow-800' },
      { min: 76, max: 95, label: 'Moderate Symptoms', color: 'bg-orange-100 text-orange-800' },
      { min: 96, max: 116, label: 'Marked Symptoms', color: 'bg-orange-200 text-orange-900' },
      { min: 117, max: 210, label: 'Severe Symptoms', color: 'bg-red-200 text-red-900' }
    ]
  },
  {
    id: 'bprs',
    code: 'BPRS',
    name: 'Brief Psychiatric Rating Scale',
    category: 'Psychosis',
    description: 'A brief 18-item scale for rapid assessment of psychiatric symptoms. Developed by Overall and Gorham (1962). Useful for screening and treatment monitoring.',
    questions: [
      {
        id: 'b1',
        text: '1. Somatic concern',
        type: QuestionType.LIKERT,
        options: scale1to7
      },
      {
        id: 'b2',
        text: '2. Anxiety',
        type: QuestionType.LIKERT,
        options: scale1to7
      },
      {
        id: 'b3',
        text: '3. Emotional withdrawal',
        type: QuestionType.LIKERT,
        options: scale1to7
      },
      {
        id: 'b4',
        text: '4. Conceptual disorganization',
        type: QuestionType.LIKERT,
        options: scale1to7
      },
      {
        id: 'b5',
        text: '5. Guilt feelings',
        type: QuestionType.LIKERT,
        options: scale1to7
      },
      {
        id: 'b6',
        text: '6. Tension',
        type: QuestionType.LIKERT,
        options: scale1to7
      },
      {
        id: 'b7',
        text: '7. Mannerisms and posturing',
        type: QuestionType.LIKERT,
        options: scale1to7
      },
      {
        id: 'b8',
        text: '8. Grandiosity',
        type: QuestionType.LIKERT,
        options: scale1to7
      },
      {
        id: 'b9',
        text: '9. Depressive mood',
        type: QuestionType.LIKERT,
        options: scale1to7
      },
      {
        id: 'b10',
        text: '10. Hostility',
        type: QuestionType.LIKERT,
        options: scale1to7
      },
      {
        id: 'b11',
        text: '11. Suspiciousness',
        type: QuestionType.LIKERT,
        options: scale1to7
      },
      {
        id: 'b12',
        text: '12. Hallucinatory behavior',
        type: QuestionType.LIKERT,
        options: scale1to7
      },
      {
        id: 'b13',
        text: '13. Motor retardation',
        type: QuestionType.LIKERT,
        options: scale1to7
      },
      {
        id: 'b14',
        text: '14. Uncooperativeness',
        type: QuestionType.LIKERT,
        options: scale1to7
      },
      {
        id: 'b15',
        text: '15. Unusual thought content',
        type: QuestionType.LIKERT,
        options: scale1to7
      },
      {
        id: 'b16',
        text: '16. Blunted affect',
        type: QuestionType.LIKERT,
        options: scale1to7
      },
      {
        id: 'b17',
        text: '17. Excitement',
        type: QuestionType.LIKERT,
        options: scale1to7
      },
      {
        id: 'b18',
        text: '18. Disorientation',
        type: QuestionType.LIKERT,
        options: scale1to7
      }
    ],
    interpretations: [
      { min: 18, max: 31, label: 'Minimal Symptoms', color: 'bg-green-100 text-green-800' },
      { min: 32, max: 45, label: 'Mild Symptoms', color: 'bg-yellow-100 text-yellow-800' },
      { min: 46, max: 58, label: 'Moderate Symptoms', color: 'bg-orange-100 text-orange-800' },
      { min: 59, max: 71, label: 'Marked Symptoms', color: 'bg-orange-200 text-orange-900' },
      { min: 72, max: 126, label: 'Severe Symptoms', color: 'bg-red-200 text-red-900' }
    ]
  }
];
